module.exports = __webpack_public_path__ + "static/media/ta.079e7c9f.jpg";